module.exports = __webpack_public_path__ + "assets/img/keeps.460e0eb6.png";